export const SET_TAXCODELIST = "SET_TAXCODELIST";
export const SET_TAXCODEMETA = "SET_TAXCODEMETA";
export const SET_TAXCODEOBJECT = "SET_TAXCODEOBJECT";

